export default ({ request }) => ({
  ecomAmzSkuOutageStatisticsListApi(data = {}) {
    return request({
      url: '/ecom/amzListing/invOutstats/list',
      method: 'POST',
      data
    })
  }
})
